export default "__VITE_PUBLIC_ASSET__beb53c59__"